import { render, staticRenderFns } from "./TreeModal.vue?vue&type=template&id=612d53de&scoped=true&"
import script from "./TreeModal.vue?vue&type=script&lang=js&"
export * from "./TreeModal.vue?vue&type=script&lang=js&"
import style0 from "./TreeModal.vue?vue&type=style&index=0&id=612d53de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d53de",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCol,VContainer,VIcon,VRow,VTextField,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('612d53de')) {
      api.createRecord('612d53de', component.options)
    } else {
      api.reload('612d53de', component.options)
    }
    module.hot.accept("./TreeModal.vue?vue&type=template&id=612d53de&scoped=true&", function () {
      api.rerender('612d53de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/GestaoUsuarios/components/TreeModal.vue"
export default component.exports